"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DrawingToolsManager_callbacks, _DrawingToolsManager_defaultTextures, _DrawingToolsManager_eventEngine, _DrawingToolsManager_eventManager, _DrawingToolsManager_geometryManager, _DrawingToolsManager_geometryMathManager, _DrawingToolsManager_historyManager, _DrawingToolsManager_interactionManager, _DrawingToolsManager_keysPressed, _DrawingToolsManager_parentNode, _DrawingToolsManager_settings, _DrawingToolsManager_textVisualizationManager, _DrawingToolsManager_uuidGenerator, _DrawingToolsManager_viewport, _DrawingToolsManager_closed, _DrawingToolsManager_continuousRenderingFlag, _DrawingToolsManager_uuid;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawingToolsManager = void 0;
const viewer_1 = require("@shapediver/viewer");
const viewer_rendering_engine_intersection_restriction_engine_1 = require("@shapediver/viewer.rendering-engine.intersection-restriction-engine");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const gl_matrix_1 = require("gl-matrix");
const GeometryManager_1 = require("./managers/geometry/GeometryManager");
const HistoryManager_1 = require("./managers/HistoryManager");
const InteractionManager_1 = require("./managers/interaction/InteractionManager");
const TextVisualizationManager_1 = require("./managers/TextVisualizationManager");
class DrawingToolsManager {
    // #endregion Properties (17)
    // #region Constructors (1)
    constructor(viewport, callbacks, settings, defaultTextures) {
        // #region Properties (17)
        _DrawingToolsManager_callbacks.set(this, void 0);
        _DrawingToolsManager_defaultTextures.set(this, void 0);
        _DrawingToolsManager_eventEngine.set(this, viewer_shared_services_1.EventEngine.instance);
        _DrawingToolsManager_eventManager.set(this, void 0);
        _DrawingToolsManager_geometryManager.set(this, void 0);
        _DrawingToolsManager_geometryMathManager.set(this, void 0);
        _DrawingToolsManager_historyManager.set(this, void 0);
        _DrawingToolsManager_interactionManager.set(this, void 0);
        _DrawingToolsManager_keysPressed.set(this, {});
        _DrawingToolsManager_parentNode.set(this, void 0);
        _DrawingToolsManager_settings.set(this, void 0);
        _DrawingToolsManager_textVisualizationManager.set(this, void 0);
        _DrawingToolsManager_uuidGenerator.set(this, viewer_shared_services_1.UuidGenerator.instance);
        _DrawingToolsManager_viewport.set(this, void 0);
        _DrawingToolsManager_closed.set(this, false);
        _DrawingToolsManager_continuousRenderingFlag.set(this, void 0);
        _DrawingToolsManager_uuid.set(this, __classPrivateFieldGet(this, _DrawingToolsManager_uuidGenerator, "f").create());
        __classPrivateFieldSet(this, _DrawingToolsManager_viewport, viewport, "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_callbacks, callbacks, "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_settings, this.cleanSettings(settings), "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_defaultTextures, defaultTextures, "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_parentNode, new viewer_1.TreeNode(`DrawingToolsManager_${__classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f")}`), "f");
        __classPrivateFieldGet(this, _DrawingToolsManager_parentNode, "f").intersectionTest = false;
        viewer_1.sceneTree.root.addChild(__classPrivateFieldGet(this, _DrawingToolsManager_parentNode, "f"));
        viewer_1.sceneTree.root.updateVersion(false, false);
        __classPrivateFieldSet(this, _DrawingToolsManager_geometryMathManager, new viewer_rendering_engine_intersection_restriction_engine_1.GeometryMathManager(__classPrivateFieldGet(this, _DrawingToolsManager_viewport, "f"), __classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").visualization), "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_geometryManager, new GeometryManager_1.GeometryManager(this), "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_interactionManager, new InteractionManager_1.InteractionManager(this), "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_textVisualizationManager, new TextVisualizationManager_1.TextVisualizationManager(this), "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_historyManager, new HistoryManager_1.HistoryManager(this), "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_eventManager, new viewer_rendering_engine_intersection_restriction_engine_1.EventManager(__classPrivateFieldGet(this, _DrawingToolsManager_viewport, "f"), {
            onDown: this.onDown.bind(this),
            onUp: this.onUp.bind(this),
            onOut: this.onOut.bind(this),
            onMove: this.onMove.bind(this),
            onKeyDown: this.onKeyDown.bind(this),
            onKeyUp: this.onKeyUp.bind(this),
        }), "f");
        __classPrivateFieldSet(this, _DrawingToolsManager_continuousRenderingFlag, __classPrivateFieldGet(this, _DrawingToolsManager_viewport, "f").addFlag(viewer_1.FLAG_TYPE.CONTINUOUS_RENDERING), "f");
        // special case, the scene is still empty, so we create a grid by default and show the scene
        if (viewer_1.sceneTree.root.boundingBox.isEmpty())
            __classPrivateFieldGet(this, _DrawingToolsManager_viewport, "f").show = true;
        // add listener for geometry changes, if autoUpdate is enabled the drawing tool will update automatically
        __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").addListener(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.GEOMETRY_CHANGED, (e) => {
            const event = e;
            if (event.temporary === false &&
                event.points !== undefined &&
                event.metaData !== undefined &&
                event.recordHistory !== false) {
                if (__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").general.autoUpdate &&
                    (__classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").insertionInteractionHandler
                        .insertionActive === false ||
                        viewer_shared_services_1.SystemInfo.instance.isMobile === true) &&
                    (__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.autoClose ||
                        __classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.close ===
                            __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").geometryState.closeLoop)) {
                    this.update();
                }
            }
        });
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (22)
    get callbacks() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_callbacks, "f");
    }
    get closed() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_closed, "f");
    }
    get defaultTextures() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_defaultTextures, "f");
    }
    get geometryManager() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f");
    }
    get geometryMathManager() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_geometryMathManager, "f");
    }
    get geometryState() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").geometryState;
    }
    get historyManager() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_historyManager, "f");
    }
    get indicesArrayLines() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").geometryState.indicesArrayLines;
    }
    get insertionActive() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").insertionInteractionHandler
            .insertionActive;
    }
    get interactionManager() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f");
    }
    get parentNode() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_parentNode, "f");
    }
    get positionArray() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").geometryState.positionArray;
    }
    get restrictionManager() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").restrictionManager;
    }
    get restrictions() {
        return this.restrictionManager.restrictions;
    }
    get settings() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_settings, "f");
    }
    get showDistanceLabels() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f").showDistanceLabels;
    }
    set showDistanceLabels(value) {
        __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f").showDistanceLabels = value;
    }
    get showPointLabels() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f").showPointLabels;
    }
    set showPointLabels(value) {
        __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f").showPointLabels = value;
    }
    get textVisualizationManager() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f");
    }
    get uuid() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f");
    }
    get viewport() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_viewport, "f");
    }
    // #endregion Public Getters And Setters (22)
    // #region Public Methods (28)
    /**
     * Add a point to the drawing tool.
     *
     * @param index
     * @param position
     * @returns
     */
    addPoint(index, position, metaData, temporary = false) {
        if (__classPrivateFieldGet(this, _DrawingToolsManager_closed, "f"))
            return false;
        if (!__classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").canAddPoint()) {
            __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.MAXIMUM_POINTS, {
                viewportId: this.viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"),
                message: `The maximum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.maxPoints}) has been exceeded.`,
            });
            throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError(`The maximum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.maxPoints}) has been exceeded.`);
        }
        return __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").addPoint(index, position, metaData, temporary);
    }
    addPointTemporary(index, position, metaData) {
        return this.addPoint(index, position, metaData, true);
    }
    /**
     * Add a ray tracing intersection restriction to the drawing tool.
     *
     * @param planeProperties
     * @returns
     */
    addRestriction(properties, token) {
        if (!properties.id)
            properties.id = token || __classPrivateFieldGet(this, _DrawingToolsManager_uuidGenerator, "f").create();
        return __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").restrictionManager.addRestriction(properties);
    }
    canRedo() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_historyManager, "f").canRedo();
    }
    canUndo() {
        return __classPrivateFieldGet(this, _DrawingToolsManager_historyManager, "f").canUndo();
    }
    cancel() {
        if (__classPrivateFieldGet(this, _DrawingToolsManager_closed, "f"))
            return;
        try {
            __classPrivateFieldGet(this, _DrawingToolsManager_callbacks, "f").onCancel();
        }
        catch (e) {
            throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError("An error occurred while cancelling the drawing tool.");
        }
        __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.CANCEL, {
            viewportId: this.viewport.id,
            drawingToolsId: __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"),
        });
        this.close();
    }
    close() {
        if (__classPrivateFieldGet(this, _DrawingToolsManager_closed, "f"))
            return;
        if (__classPrivateFieldGet(this, _DrawingToolsManager_continuousRenderingFlag, "f"))
            __classPrivateFieldGet(this, _DrawingToolsManager_viewport, "f").removeFlag(__classPrivateFieldGet(this, _DrawingToolsManager_continuousRenderingFlag, "f"));
        __classPrivateFieldGet(this, _DrawingToolsManager_eventManager, "f").close();
        __classPrivateFieldGet(this, _DrawingToolsManager_geometryMathManager, "f").close();
        __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").close();
        __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").close();
        __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f").close();
        viewer_1.sceneTree.root.removeChild(__classPrivateFieldGet(this, _DrawingToolsManager_parentNode, "f"));
        viewer_1.sceneTree.root.updateVersion(false, false);
        __classPrivateFieldSet(this, _DrawingToolsManager_closed, true, "f");
    }
    getPointsData() {
        return this.geometryState.getPointsData();
    }
    keyPressed(key) {
        if (Array.isArray(key)) {
            // check if one of the keys is pressed
            let result = false;
            for (let i = 0; i < key.length; i++) {
                result = result || this.keyPressCheck(key[i]);
            }
            return result;
        }
        else {
            return this.keyPressCheck(key);
        }
    }
    movePoint(index, position, metaData, temporary = false) {
        __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").movePoint(index, position, metaData, temporary);
    }
    movePointTemporary(index, position, metaData) {
        this.movePoint(index, position, metaData, true);
    }
    onDown(event, ray) {
        if (this.closed)
            return;
        __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").onDown(event, ray);
    }
    onKeyDown(event, pointerInCanvas) {
        if (this.closed)
            return;
        if (!pointerInCanvas)
            return;
        __classPrivateFieldGet(this, _DrawingToolsManager_keysPressed, "f")[event.key] = true;
        const undoKeyPressed = this.keyPressed(__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").controls.undo);
        const redoKeyPressed = this.keyPressed(__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").controls.redo);
        /**
         * IF UNDO KEY IS PRESSED
         * - UNDO
         */
        if (undoKeyPressed) {
            __classPrivateFieldGet(this, _DrawingToolsManager_historyManager, "f").undo();
        }
        /**
         * IF REDO KEY IS PRESSED
         * - REDO
         */
        if (redoKeyPressed) {
            __classPrivateFieldGet(this, _DrawingToolsManager_historyManager, "f").redo();
        }
        __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").onKeyDown();
    }
    onKeyUp(event, pointerInCanvas) {
        if (this.closed)
            return;
        __classPrivateFieldGet(this, _DrawingToolsManager_keysPressed, "f")[event.key] = false;
    }
    onMove(event, ray) {
        if (this.closed)
            return;
        if (!__classPrivateFieldGet(this, _DrawingToolsManager_continuousRenderingFlag, "f"))
            __classPrivateFieldSet(this, _DrawingToolsManager_continuousRenderingFlag, __classPrivateFieldGet(this, _DrawingToolsManager_viewport, "f").addFlag(viewer_1.FLAG_TYPE.CONTINUOUS_RENDERING), "f");
        __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").onMove(event, ray);
    }
    onOut() {
        if (this.closed)
            return;
        __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").onOut();
        if (__classPrivateFieldGet(this, _DrawingToolsManager_continuousRenderingFlag, "f") &&
            viewer_shared_services_1.SystemInfo.instance.isMobile === false) {
            __classPrivateFieldGet(this, _DrawingToolsManager_viewport, "f").removeFlag(__classPrivateFieldGet(this, _DrawingToolsManager_continuousRenderingFlag, "f"));
            __classPrivateFieldSet(this, _DrawingToolsManager_continuousRenderingFlag, undefined, "f");
        }
    }
    onUp(event) {
        if (this.closed)
            return;
        __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").onUp(event);
    }
    redo() {
        __classPrivateFieldGet(this, _DrawingToolsManager_historyManager, "f").redo();
    }
    /**
     * Remove a point from the drawing tool.
     *
     * @param index
     * @returns
     */
    removePoint(index, temporary = false) {
        if (__classPrivateFieldGet(this, _DrawingToolsManager_closed, "f"))
            return false;
        if (!this.geometryState.canRemovePoint()) {
            __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.MINIMUM_POINTS, {
                viewportId: this.viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"),
                message: `The minimum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.minPoints}) has not been met.`,
            });
            throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError(`The minimum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.minPoints}) has not been met.`);
        }
        return __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").removePoint(index, temporary);
    }
    removePointTemporary(index) {
        return this.removePoint(index, true);
    }
    removePoints(indices) {
        if (__classPrivateFieldGet(this, _DrawingToolsManager_closed, "f"))
            return;
        if (!this.geometryState.canRemovePoint(indices.length)) {
            __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.MINIMUM_POINTS, {
                viewportId: this.viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"),
                message: `The minimum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.minPoints}) has not been met.`,
            });
            throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError(`The minimum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.minPoints}) has not been met.`);
        }
        __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").removePoints(indices);
    }
    /**
     * Remove a restriction from the drawing tool.
     *
     * @param token
     */
    removeRestriction(token) {
        __classPrivateFieldGet(this, _DrawingToolsManager_interactionManager, "f").restrictionManager.removeRestriction(token);
    }
    resetMaterialIndices() {
        __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").resetMaterialIndices();
    }
    undo() {
        __classPrivateFieldGet(this, _DrawingToolsManager_historyManager, "f").undo();
    }
    update() {
        if (__classPrivateFieldGet(this, _DrawingToolsManager_closed, "f"))
            return;
        const pointsCount = this.geometryState.getPointCount();
        if (__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.minPoints !== undefined &&
            pointsCount < __classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.minPoints) {
            __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.MINIMUM_POINTS, {
                viewportId: this.viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"),
                message: `The minimum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.minPoints}) has not been met. Current number of points: ${pointsCount}.`,
            });
            throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError(`The minimum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.minPoints}) has not been met. Current number of points: ${pointsCount}.`);
        }
        else if (__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.maxPoints !== undefined &&
            pointsCount > __classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.maxPoints) {
            __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.MAXIMUM_POINTS, {
                viewportId: this.viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"),
                message: `The maximum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.maxPoints}) has been exceeded. Current number of points: ${pointsCount}.`,
            });
            throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError(`The maximum amount of points (${__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.maxPoints}) has been exceeded. Current number of points: ${pointsCount}.`);
        }
        else if (__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.mode === "lines" &&
            !(__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.autoClose ||
                __classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").geometry.close ===
                    __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").geometryState.closeLoop) &&
            pointsCount > 2) {
            __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.UNCLOSED_LOOP, {
                viewportId: this.viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"),
                message: "The geometry is not closed, but is required to be closed.",
            });
            throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError("The geometry is not closed, but is required to be closed.");
        }
        else {
            const pointsData = this.geometryState.getPointsData();
            try {
                __classPrivateFieldGet(this, _DrawingToolsManager_callbacks, "f").onUpdate(pointsData, this.geometryState.metadataArray);
                __classPrivateFieldGet(this, _DrawingToolsManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.UPDATE, {
                    viewportId: this.viewport.id,
                    drawingToolsId: __classPrivateFieldGet(this, _DrawingToolsManager_uuid, "f"),
                });
            }
            catch (e) {
                throw new viewer_shared_services_1.ShapeDiverViewerDrawingToolsError("An error occurred while updating the drawing tool.");
            }
            if (__classPrivateFieldGet(this, _DrawingToolsManager_settings, "f").general.closeOnUpdate)
                this.close();
            return {
                pointsData,
                metaData: this.geometryState.metadataArray,
            };
        }
    }
    updateMaterialIndex(index, materialIndex) {
        __classPrivateFieldGet(this, _DrawingToolsManager_geometryManager, "f").updateMaterialIndex(index, materialIndex);
    }
    updateTextVisualization() {
        __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f").createPointLabels();
        __classPrivateFieldGet(this, _DrawingToolsManager_textVisualizationManager, "f").createDistanceLabels();
    }
    // #endregion Public Methods (28)
    // #region Private Methods (2)
    cleanSettings(settingsOptional) {
        if (typeof settingsOptional === "string")
            settingsOptional = JSON.parse(settingsOptional);
        const settings = {
            geometry: {
                points: [],
                mode: "lines",
                close: true,
                autoClose: false,
            },
            restrictions: {},
            visualization: {
                distanceMultiplicationFactor: 2,
                pointLabels: false,
                distanceLabels: true,
                points: {
                    size_0: 15,
                    size_1: 20,
                    size_2: 15,
                    size_3: 20,
                    size_4: 15,
                    size_5: 20,
                    color_0: "#0d44f0",
                    color_1: "#197aeb",
                    color_2: "#9e27d8",
                    color_3: "#bc47fd",
                    color_4: "#00ff78",
                    color_5: "#00ff78",
                },
                lines: {
                    color: "#0d44f0",
                },
            },
            controls: {
                insert: ["Insert", "+"],
                delete: ["Delete", "-"],
                confirm: "Enter",
                cancel: "Escape",
                undo: "Control+z",
                redo: "Control+y",
            },
            general: {
                autoStart: true,
                autoUpdate: false,
                closeOnUpdate: false,
                displayUnit: "",
            },
        };
        const isUndefinedOrNull = (value) => value === undefined || value === null;
        if (!isUndefinedOrNull(settingsOptional.geometry)) {
            settings.geometry = {
                points: isUndefinedOrNull(settingsOptional.geometry.points)
                    ? []
                    : settingsOptional.geometry.points,
                mode: settingsOptional.geometry.mode === "points"
                    ? "points"
                    : "lines",
                minPoints: settingsOptional.geometry.minPoints,
                maxPoints: settingsOptional.geometry.maxPoints,
                strictMinMaxPoints: isUndefinedOrNull(settingsOptional.geometry.strictMinMaxPoints)
                    ? true
                    : settingsOptional.geometry.strictMinMaxPoints,
                close: isUndefinedOrNull(settingsOptional.geometry.close)
                    ? true
                    : settingsOptional.geometry.close,
                autoClose: isUndefinedOrNull(settingsOptional.geometry.autoClose)
                    ? true
                    : settingsOptional.geometry.autoClose,
            };
        }
        if (!isUndefinedOrNull(settingsOptional.visualization)) {
            settings.visualization = {
                distanceMultiplicationFactor: isUndefinedOrNull(settingsOptional.visualization.distanceMultiplicationFactor)
                    ? 2
                    : settingsOptional.visualization
                        .distanceMultiplicationFactor,
                pointLabels: isUndefinedOrNull(settingsOptional.visualization.pointLabels)
                    ? false
                    : settingsOptional.visualization.pointLabels,
                distanceLabels: isUndefinedOrNull(settingsOptional.visualization.distanceLabels)
                    ? true
                    : settingsOptional.visualization.distanceLabels,
                points: isUndefinedOrNull(settingsOptional.visualization.points)
                    ? {
                        size_0: 15,
                        size_1: 20,
                        size_2: 15,
                        size_3: 20,
                        size_4: 15,
                        size_5: 20,
                        color_0: "#0d44f0",
                        color_1: "#197aeb",
                        color_2: "#9e27d8",
                        color_3: "#bc47fd",
                        color_4: "#00ff78",
                        color_5: "#00ff78",
                    }
                    : settingsOptional.visualization.points,
                lines: isUndefinedOrNull(settingsOptional.visualization.lines)
                    ? {
                        color: "#0d44f0",
                    }
                    : settingsOptional.visualization.lines,
                wireframe: isUndefinedOrNull(settingsOptional.visualization.wireframe)
                    ? undefined
                    : settingsOptional.visualization.wireframe,
                wireframeColor: isUndefinedOrNull(settingsOptional.visualization.wireframeColor)
                    ? undefined
                    : settingsOptional.visualization.wireframeColor,
            };
        }
        if (!isUndefinedOrNull(settingsOptional.controls)) {
            settings.controls = {
                insert: isUndefinedOrNull(settingsOptional.controls.insert)
                    ? ["Insert", "+"]
                    : settingsOptional.controls.insert,
                delete: isUndefinedOrNull(settingsOptional.controls.delete)
                    ? ["Delete", "-"]
                    : settingsOptional.controls.delete,
                confirm: isUndefinedOrNull(settingsOptional.controls.confirm)
                    ? "Enter"
                    : settingsOptional.controls.confirm,
                cancel: isUndefinedOrNull(settingsOptional.controls.cancel)
                    ? "Escape"
                    : settingsOptional.controls.cancel,
                undo: isUndefinedOrNull(settingsOptional.controls.undo)
                    ? "Control+z"
                    : settingsOptional.controls.undo,
                redo: isUndefinedOrNull(settingsOptional.controls.redo)
                    ? "Control+y"
                    : settingsOptional.controls.redo,
            };
        }
        if (!isUndefinedOrNull(settingsOptional.general)) {
            settings.general = {
                autoStart: isUndefinedOrNull(settingsOptional.general.autoStart)
                    ? true
                    : settingsOptional.general.autoStart,
                autoUpdate: isUndefinedOrNull(settingsOptional.general.autoUpdate)
                    ? false
                    : settingsOptional.general.autoUpdate,
                closeOnUpdate: isUndefinedOrNull(settingsOptional.general.closeOnUpdate)
                    ? false
                    : settingsOptional.general.closeOnUpdate,
                displayUnit: isUndefinedOrNull(settingsOptional.general.displayUnit)
                    ? ""
                    : settingsOptional.general.displayUnit,
            };
        }
        const min = gl_matrix_1.vec3.fromValues(Infinity, Infinity, Infinity);
        const max = gl_matrix_1.vec3.fromValues(-Infinity, -Infinity, -Infinity);
        for (let i = 0; i < settings.geometry.points.length; i++) {
            const point = settings.geometry.points[i];
            min[0] = Math.min(min[0], point[0]);
            min[1] = Math.min(min[1], point[1]);
            min[2] = Math.min(min[2], point[2]);
            max[0] = Math.max(max[0], point[0]);
            max[1] = Math.max(max[1], point[1]);
            max[2] = Math.max(max[2], point[2]);
        }
        if (isUndefinedOrNull(settingsOptional.restrictions) ||
            Object.keys(settingsOptional.restrictions).length === 0) {
            settings.restrictions["plane"] = { type: viewer_rendering_engine_intersection_restriction_engine_1.RESTRICTION_TYPE.PLANE };
        }
        else {
            settings.restrictions = settingsOptional.restrictions;
        }
        return settings;
    }
    keyPressCheck(key) {
        const pressedKeys = Object.keys(__classPrivateFieldGet(this, _DrawingToolsManager_keysPressed, "f")).filter((key) => __classPrivateFieldGet(this, _DrawingToolsManager_keysPressed, "f")[key] === true);
        // check if it the only key that is pressed
        if (key.includes("+") && key.length > 1) {
            const keys = key.split("+");
            // there are more keys pressed than the keys in the combination
            if (keys.length !== pressedKeys.length)
                return false;
            let result = true;
            for (let i = 0; i < keys.length; i++)
                result = result && (__classPrivateFieldGet(this, _DrawingToolsManager_keysPressed, "f")[keys[i]] || false);
            return result;
        }
        else {
            // there are also other keys pressed
            if (pressedKeys.length > 1)
                return false;
            return __classPrivateFieldGet(this, _DrawingToolsManager_keysPressed, "f")[key] || false;
        }
    }
}
exports.DrawingToolsManager = DrawingToolsManager;
_DrawingToolsManager_callbacks = new WeakMap(), _DrawingToolsManager_defaultTextures = new WeakMap(), _DrawingToolsManager_eventEngine = new WeakMap(), _DrawingToolsManager_eventManager = new WeakMap(), _DrawingToolsManager_geometryManager = new WeakMap(), _DrawingToolsManager_geometryMathManager = new WeakMap(), _DrawingToolsManager_historyManager = new WeakMap(), _DrawingToolsManager_interactionManager = new WeakMap(), _DrawingToolsManager_keysPressed = new WeakMap(), _DrawingToolsManager_parentNode = new WeakMap(), _DrawingToolsManager_settings = new WeakMap(), _DrawingToolsManager_textVisualizationManager = new WeakMap(), _DrawingToolsManager_uuidGenerator = new WeakMap(), _DrawingToolsManager_viewport = new WeakMap(), _DrawingToolsManager_closed = new WeakMap(), _DrawingToolsManager_continuousRenderingFlag = new WeakMap(), _DrawingToolsManager_uuid = new WeakMap();
//# sourceMappingURL=DrawingToolsManager.js.map